module.exports = __webpack_public_path__ + "files/a079dd52f33cf58b263529a46b084474.svg";